// src/app/layout/components/navbar/navbar-notification/navbar-notification.component.ts
import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";
import { NavbarService } from "../navbar.service";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";
import { Notifications } from "app/services/models/notification.model";
import { NotificationsService } from "./notifications.service";
import { CurrentService } from "app/services/current.service";
import { NotificationGraphQLService } from "app/services/notification-graphql.service";

@Component({
  selector: "app-navbar-notification",
  templateUrl: "./navbar-notification.component.html",
})
export class NavbarNotificationComponent implements OnInit, OnDestroy {
  public notifications: Notifications[] = [];
  public unreadCount: number = 0;
  private subscriptions: Subscription[] = [];
  public isNotificationOpen = false;
  @ViewChild("notificationDropdown") notificationDropdown: NgbDropdown;
  public failedPushNotifications = 0;
  public currentUser = this.currentService.currentUser.getValue();

  constructor(
    private navbarService: NavbarService,
    private currentService: CurrentService,
    private notificationsService: NotificationsService,
    private notificationGraphQL: NotificationGraphQLService
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.navbarService.notificationOpen$.subscribe((isOpen) => {
        if (isOpen !== this.isNotificationOpen) {
          this.toggleNotification();
        }
      })
    );
    this.subscriptions.push(
      this.notificationsService.currentNotifications$.subscribe((notifications) => {
        this.notifications = notifications;
      })
    );
    this.subscriptions.push(
      this.notificationsService.unreadCount$.subscribe((count) => {
        this.unreadCount = count;
      })
    );

    // Charger les notifications et le compteur initial
    this.notificationsService.loadCurrentUserNotifications();
    this.notificationsService.loadUnreadCount();

    this.subscriptions.push(
      this.notificationGraphQL.newNotification$.subscribe((notification) => {
        if (notification) {
          this.handleNewNotification(notification);
        }
      })
    );

    this.subscriptions.push(
      this.notificationGraphQL.readNotification$.subscribe((notification) => {
        if (notification) {
          this.handleReadNotification(notification);
        }
      })
    );

    this.subscriptions.push(
      this.notificationGraphQL.notificationCount$.subscribe((count) => {
        this.unreadCount = count;
      })
    );
  }

  toggleNotification() {
    this.isNotificationOpen = !this.isNotificationOpen;

    if (this.notificationDropdown) {
      if (this.isNotificationOpen) {
        this.notificationDropdown.open();
      } else {
        this.notificationDropdown.close();
      }
    }
  }

  markAsRead(notification: Notifications): void {
    this.notificationsService.markAsRead(notification.id).subscribe();
  }

  markAllAsRead(): void {
    const user = this.currentService.currentUser.getValue();
    if (user?.id) {
      this.notificationsService.markAllAsRead(user.id).subscribe();
    }
  }

  navigateToNotification(notification: Notifications): void {
    console.log("Navigating to notification target:", notification);
    this.notificationsService.navigateToNotificationTarget(notification);
    this.isNotificationOpen = false;
    if (this.notificationDropdown) {
      this.notificationDropdown.close();
    }
  }

  getNotificationIcon(type: string): string {
    const lowerType = type.toLowerCase();

    if (lowerType.includes("loyalty") || lowerType.includes("points")) return "award";
    if (lowerType.includes("booking")) return "calendar";
    if (lowerType.includes("payment")) return "credit-card";
    if (lowerType.includes("trip")) return "map";
    if (lowerType.includes("appointment")) return "clock";
    if (lowerType.includes("system")) return "bell";

    return "info";
  }

  getNotificationClass(type: string): string {
    const lowerType = type.toLowerCase();

    if (lowerType.includes("loyalty") || lowerType.includes("points")) return "bg-light-primary";
    if (lowerType.includes("booking")) return "bg-light-success";
    if (lowerType.includes("payment")) return "bg-light-warning";
    if (lowerType.includes("trip")) return "bg-light-info";
    if (lowerType.includes("appointment")) return "bg-light-warning";
    if (lowerType.includes("system")) return "bg-light-secondary";

    return "bg-light-secondary";
  }

  private handleNewNotification(notification: Notifications): void {
    // Ajouter à la liste des notifications
    this.notifications.unshift(notification);

    // Recharger la liste complète pour s'assurer de la cohérence
    this.notificationsService.loadCurrentUserNotifications();

    // Afficher un toast (optionnel, déjà géré par le service)
    // this.toastr.info(notification.message, notification.title);
  }

  private handleReadNotification(notification: Notifications): void {
    // Mettre à jour dans la liste
    const index = this.notifications.findIndex((n) => n.id === notification.id);
    if (index !== -1) {
      this.notifications[index] = notification;
    }

    // Recharger la liste complète pour s'assurer de la cohérence
    this.notificationsService.loadCurrentUserNotifications();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
